import { createApp } from "vue";
import VueCookies from "vue-cookies";

const app = createApp({});
app.use(VueCookies);

// 设置 Token 到 Cookie 中，并设置失效时间
export function setToken(token) {
  const expirationDate = new Date();
  // expirationDate.setTime(expirationDate.getTime() + 1 * 60 * 1000); // 设置失效时间为8小时后
  expirationDate.setTime(expirationDate.getTime() + 8 * 60 * 60 * 1000); // 设置失效时间为8小时后
  // expirationDate.setDate(expirationDate.getDate() + 7); // 设置失效时间为7天后
  app.config.globalProperties.$cookies.set("token", token, expirationDate);
}

// 从 Cookie 中获取 Token
export function getToken() {
  return app.config.globalProperties.$cookies.get("token");
}

// 删除 Cookie 中的 Token
export function removeToken() {
  app.config.globalProperties.$cookies.remove("token");
}
